import useRequestImmutable from "@shared/hooks/useRequestImmutable";
import { useRouter } from "next/router";

import SingleCollectionCard from "./single-collection-card";
import howToLearnApi from "../helpers/howToLearnApi";
import RelatedLandingsLoading from "./RelatedLandingLoading";
import { IHowToLearnLandingData } from "@features/home/helpers/types";

const RelatedLandings: React.FC = () => {
  const router = useRouter();
  const { data } = useRequestImmutable(
    howToLearnApi.singleHowToLearnRelated(String(router.query.slug)),
    { shouldRetryOnError: false }
  );

  if (!data) return <RelatedLandingsLoading />;
  if (!data.data?.length) return null;

  return (
    <div className=" bg-fds-canvas-secondary  w-full">
      <div className=" w-full    px-4 py-8 md:px-6 lg:py-12  xl:px-0 xl:max-w-[1200px] mx-auto    ">
        <p className="md:headline-lg headline-md">دسته‌بندی‌های آموزشی مرتبط</p>
        <div className="w-full grid  md:grid-cols-2 grid-cols-1 lg:mt-8 mt-6 gap-3.5 lg:gap-8      ">
          {data.data.map((item: IHowToLearnLandingData) => {
            return (
              <SingleCollectionCard
                key={item.id}
                student={item.count_students}
                product={item.count_product}
                slug={item.slug}
                title={item.title}
                svg_image={item.svg_image}
                png_image={item.png_image}
                duration={item.total_time_hour}
                isFavorite={item.is_favorite}
                id={item.id}
              />
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default RelatedLandings;
